import { SetupCall } from '@driscollsinc/driscolls-display-rules';
import { LOOKUP_FIELDS } from '../constants';
import { lookupSetupFields } from './CommonSetupFields';

function configureSetupCall() {
    SetupCall(
        LOOKUP_FIELDS.FamilyEntityLookUp,
        [...lookupSetupFields],
        {}, //options
        (data) => {
            console.log('FamilyEntityLookUp REDUCER-- ', data);
        }
    );
}

const FamilyEntityLookUp = {
    configureSetupCall
};

export default FamilyEntityLookUp;
